import type { Driver } from '@/types/driver'

interface ItemProps {
  item: Driver;
}

export const Item = ({ item }: ItemProps) => (
  <div className="flex flex-col">
    <span className="text-sm font-medium">{item.Name}</span>
    <div className="flex gap-2 items-center">
      <span className="text-xs text-default-400">{item.Phone}</span>
      {item.Vehicle && (
        <>
          <span className="text-xs text-default-400">•</span>
          <span className="text-xs text-primary">{item.Vehicle.Number}</span>
        </>
      )}
    </div>
  </div>
)
